import { createContext } from 'react'
import type { ReactNode } from 'react'
import type { OnboardingState } from '@/types/onboarding'

export interface ForwardActionConfig {
  label: ReactNode
  onClick: () => void | Promise<void>
  disabled?: boolean
}

export interface OnboardingContextType {
  state: OnboardingState
  goToStep: (step: number) => void
  setStepData: (step: number, data: unknown) => void
  markCompleted: (step: number) => void
  forwardAction: ForwardActionConfig | null
  setForwardAction: (action: ForwardActionConfig | null) => void
}

export const OnboardingContext = createContext<OnboardingContextType | null>(null)
